import React, { useState, useEffect } from 'react';

import { useOptIn, useDismiss } from './hooks';

import { CookieBanner, CookiePreferences } from './components';

function CookieBannerContainer({
  showPreferences,
  levels,
  containerWidth = 1024,
  onLearnMore = () => {},
  onPreferencesDismiss,
  onChange,
  onViewCookiePolicy,
}) {
  const levelNames = levels.map(({ level }) => level);

  const [dismissed, onDismiss] = useDismiss();
  const [optIn, onOptInAll, onOptIn, onOptOut] = useOptIn(levelNames);
  const [showCookiePreferences, setShowCookiePreferences] = useState(showPreferences);

  useEffect(() => {
    setShowCookiePreferences(showPreferences);
  }, [showPreferences]);

  useEffect(() => {
    onChange({ optIn });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [optIn]);

  useEffect(() => {
    onChange({ optIn });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  if (showCookiePreferences) {
    return (
      <CookiePreferences
        optIn={optIn}
        levels={levels}
        containerWidth={containerWidth}
        onDismiss={() => {
          setShowCookiePreferences(false);
          onPreferencesDismiss();
          onDismiss();
        }}
        onOptIn={onOptIn}
        onOptOut={onOptOut}
        onViewCookiePolicy={onViewCookiePolicy}
      />
    );
  }

  if (dismissed) {
    return null;
  }

  return (
    <CookieBanner
      containerWidth={containerWidth}
      onOptInAll={() => {
        onOptInAll();
        onDismiss();
      }}
      onDismiss={onDismiss}
      onLearnMore={() => {
        setShowCookiePreferences(true);
      }}
      onViewCookiePolicy={onViewCookiePolicy}
    />
  );
}

export { useOptIn };
export default CookieBannerContainer;
